import { debounce } from "lodash";
import { makeItemDataSample, makeEmptyDataSample } from "./index.preview";
import { debuglog } from "../utility/debuglog";
import { toAlias } from "./theme";

let isLongText = false;

export default [
  {
    name: 'Simulation',
    class: 'btn-reload-simulation',
    label: 'Simulation',
    exec: (manager) => {
      setDefaultSetting(manager)
      const times = [ 500, 1100, 1200, 2000, 3000, 3200, 3600, 4000, 4200 ];
      let simulationRIS = 0;
      let items = [];

      // simulation running in seconds

      setInterval(() => {
        simulationRIS += 100
      }, 100)

      times.forEach((ms) => {
        setTimeout(() => {
          reloadSimulation();
        }, ms);
      });

      function reloadSimulation() {
        const useNominal = manager.get('ts_sortby') == 'nominal';
        const unit = Math.floor(Math.random() * 100);
        const no = Math.floor(Math.random() * 21) + 1;
        const item = makeItemDataSample(no, useNominal ? unit * 100 : unit);
        
        // Log Printing
        const alias = toAlias(item.supporter_name);
        debuglog(`[${simulationRIS}ms] Update <strong>${alias.currentAlias}</strong>, traktiran 💰${unit}`);

        items.push(item);
        handlersimulationRIS(simulationRIS);
      }

      let handlersimulationRIS = debounce((ms) => {
        debuglog(`[${simulationRIS}ms] Reload data from [${ms}ms]`);

        items.forEach(item => {
          updateDataSimulation(manager, item);
        });
        items = [];

      }, 200, { 'maxWait': 1000 });
    },
  },
  {
    name: 'Add Item',
    class: 'btn-add-item',
    label: 'Add Item',
    exec: (manager) => {
      setDefaultSetting(manager)
      let sampleNominal = [1000, 2700, 3400, 2100, 8400, 10300, 9000, 5100, 4400, 3800, 8000];
      let sampleUnit = [10, 27, 34, 21, 84, 103, 90, 51, 44, 38, 80];

      const useNominal = manager.get('ts_sortby') == 'nominal';
      let unit = useNominal ? h.selectRandom(sampleNominal) : h.selectRandom(sampleUnit);

      const no = Math.floor(Math.random() * 21) + 1;
      const item = makeItemDataSample(no, unit);
      updateDataSimulation(manager, item);

      const alias = toAlias(item.supporter_name);
      debuglog(`Update <strong>${alias.currentAlias}</strong>, traktiran 💰${item.sum}`);
    }
  },
  {
    name: 'Bulk Update',
    class: 'btn-bulk-update',
    label: 'Bulk Update',
    exec: (manager) => {
      setDefaultSetting(manager)

      let tempItems = h.cloneProp(manager.widget.data.supporter || []);
      let items = [];
      for (let i = 0; i < 20; i++) {
        const unit = Math.floor(Math.random() * 100);
        let item = makeItemDataSample(i + 1, unit);

        const tempIndex = tempItems.findIndex(tempItem => tempItem.uid === item.uid);
        if (tempIndex > -1) {
          item.sum += tempItems[tempIndex].sum;
        }
  
        items[i] = item;

        const alias = toAlias(item.supporter_name);
        debuglog(`Update <strong>${alias.currentAlias}</strong>, traktiran 💰${item.sum}`);
      }

      items.sort((a, b) => b.sum - a.sum); //sort array supporter
      items = items.slice(0, manager.widget.ts_count());

      let data = makeEmptyDataSample();
      data.supporter = items;
      manager.reload(data);
    }
  },
  {
    name: 'Reset',
    class: 'btn-reset',
    label: 'Reset',
    exec: (manager) => {
      debuglog(`Reset data`)
      setDefaultSetting(manager)
      manager.reload(makeEmptyDataSample());
    }
  },
  {
    name: 'LongText',
    class: 'btn-debug-longtext',
    label: 'Long Text',
    exec: (manager) => {
      isLongText = true;
      let text = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
      manager.widget.setting['ts_customtitle'] = text;
      manager.widget.setting['ts_customsubtitle'] = text;
      let tempSupporter = [
        {
          avatar: "https://edge-cdn.trakteer.id/images/mix/default-avatar.png",
          sum: 999999999,
          supporter_name: "Lorem ipsum dolor sit amet, consectetur adipiscing elit_!!!_sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
          uid: "sample-longtext-1",
        },
        {
          avatar: "https://edge-cdn.trakteer.id/images/mix/default-avatar.png",
          sum: 999999,
          supporter_name: " Ut enim ad minim veniam_!!!_quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
          uid: "sample-longtext-2",
        },
      ];
      let temp = h.cloneProp(manager.widget.data);
      temp.supporter = tempSupporter
      manager.reload(temp);
      debuglog(`Check long text input`);
    }
  },
];

function updateDataSimulation(manager, item) {
  let tempItems = h.cloneProp(manager.widget.data.supporter || []);

  const tempIndex = tempItems.findIndex(tempItem => tempItem.uid === item.uid);
  if (tempIndex > -1) {
    item.sum += tempItems[tempIndex].sum;
    tempItems[tempIndex] = item;
  } else {
    tempItems.push(item);
  }
  tempItems.sort((a, b) => b.sum - a.sum); //sort array supporter
  tempItems = tempItems.slice(0, manager.widget.ts_count());

  let params = makeEmptyDataSample();
  params.supporter = tempItems;

  manager.reload(params);
}

async function setDefaultSetting(manager) {
  if(isLongText) {
    isLongText = false;
    manager.widget.setting['ts_customtitle'] = h.args('ts_customtitle') || "Leaderboard";
    manager.widget.setting['ts_customsubtitle'] = h.args('ts_customsubtitle') || "Top Supporter";
    manager.reload(makeEmptyDataSample());
  }
}